import React from "react";

const OptionsList: React.FC = () => {
  return (
    <svg
      width="58"
      height="48"
      viewBox="0 0 58 48"
      fill="none"
      data-testid="options-list"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 440">
        <rect
          id="Rectangle 796"
          width="47"
          height="14"
          rx="3"
          fill="url(#paint0_linear_9793_14638)"
        />
        <rect
          id="Rectangle 797"
          y="17"
          width="58"
          height="14"
          rx="3"
          fill="url(#paint1_linear_9793_14638)"
        />
        <rect
          id="Rectangle 798"
          y="34"
          width="47"
          height="14"
          rx="3"
          fill="url(#paint2_linear_9793_14638)"
        />
        <path
          id="Vector"
          d="M32.9067 33.5027C34.1458 34.6695 35.3353 35.7886 36.523 36.9086C36.9578 37.3186 36.9578 37.4334 36.523 37.8466C35.8993 38.4364 35.2747 39.0254 34.6492 39.6135C34.2075 40.0284 34.0901 40.0309 33.6554 39.6209C32.5581 38.5878 31.4616 37.5545 30.366 36.5208C30.2669 36.4273 30.1599 36.3404 30.0182 36.2199L28.3148 39.4225C28.114 39.8005 27.9349 40.1907 27.7062 40.5515C27.5923 40.7294 27.381 40.8524 27.214 41C27.0575 40.8426 26.8349 40.7106 26.7549 40.5244C25.7698 38.2394 24.8064 35.9502 23.836 33.6544C22.5908 30.7191 21.3445 27.7838 20.0971 24.8485C20.0547 24.7777 20.0253 24.7007 20.0101 24.6206C20.0101 24.4312 19.9641 24.1893 20.0684 24.068C20.1467 23.977 20.4492 23.986 20.6153 24.0442C21.4848 24.3468 22.3387 24.678 23.1969 25.0019C27.9473 26.7942 32.6969 28.5873 37.4456 30.3813C37.5831 30.4226 37.7141 30.4811 37.8351 30.5551C38.1142 30.7568 38.0316 31.0692 37.643 31.2537C36.2222 31.9288 34.7997 32.6 33.3754 33.2674C33.2345 33.3346 33.0989 33.4084 32.9067 33.5027Z"
          fill="#071443"
        />
        <circle
          id="Ellipse 166"
          cx="7.37199"
          cy="7.18644"
          r="3.18644"
          fill="white"
        />
        <circle
          id="Ellipse 167"
          cx="7.37199"
          cy="24.1864"
          r="3.18644"
          fill="white"
        />
        <circle
          id="Ellipse 168"
          cx="7.37199"
          cy="41.1864"
          r="3.18644"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_9793_14638"
          x1="5.15079"
          y1="3.53579e-06"
          x2="38.0319"
          y2="12.4959"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADACEE" />
          <stop offset="1" stopColor="#BED8FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_9793_14638"
          x1="14.5"
          y1="17"
          x2="53.4168"
          y2="35.8772"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BEA0FE" />
          <stop offset="1" stopColor="#BFD9FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_9793_14638"
          x1="5.15079"
          y1="34"
          x2="38.0319"
          y2="46.4959"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADACEE" />
          <stop offset="1" stopColor="#BED8FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default OptionsList;
